export const getNodeId = (matchupId: Number, bearPosition: Number) => `node-${matchupId}-${bearPosition}`;